// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CxF5","right":"styles_right__17Tvz"};